import { LOW_BALANCE_AMOUNT, DEFAULT_LANGUAGE, SUPPORTED_CULTURES } from '@/utils/constants'
import { isNullOrUndefined } from '@/utils/comparators'
import { Translation } from '@/utils/Translation'

const getUserData = (state) => {
  return state
}

const locale = (state) => {
  if (isNullOrUndefined(state.locales) || state.locales.length === 0) {
    return DEFAULT_LANGUAGE
  }

  let locale = state.locales[0]
  if (locale.length === 2) {
    return locale
  }

  let found = SUPPORTED_CULTURES.filter((s) => s.culture === locale)
  return found.length
    ? found[0].twoLetter
    : DEFAULT_LANGUAGE
}

const localeCulture = (state, getters) => {
  return Translation.getLocaleCulture(getters.locale)
}

const currency = (state) => {
  if (!isNullOrUndefined(state.currency)) {
    return state.currency
  }
}

const geolocation = (state) => {
  if (!isNullOrUndefined(state.geolocation)) {
    return state.geolocation
  }
}

const userId = (state) => {
  if (!isNullOrUndefined(state.id)) {
    return state.id
  }
}

const balanceIsLow = (state) => {
  return state.balanceAmount <= LOW_BALANCE_AMOUNT && state.balanceAmount !== 0
}

const hasBonusMinutes = (state) => {
  if (isNullOrUndefined(state.bonusMinutes)) {
    return false
  }

  return state.bonusMinutes !== 0
}

const loggedIn = (state) => {
  return !!state.id
}

const getPaymentCount = (state) => {
  return state.paymentCount
}

const userServices = (state) => {
  if (!isNullOrUndefined(state.userServices)) {
    return state.userServices
  }
  return []
}

export default {
  getUserData,
  locale,
  localeCulture,
  currency,
  geolocation,
  userId,
  balanceIsLow,
  hasBonusMinutes,
  getPaymentCount,
  loggedIn,
  userServices
}



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js